import { useEffect, useState } from 'react';

/** Phones: below Tailwind's md breakpoint. */
export const PHONE_QUERY = '(max-width: 767px)';
/** Below Tailwind's lg breakpoint, where two-column layouts stack. */
export const BELOW_LG_QUERY = '(max-width: 1023px)';

/** True while the media query matches; follows resizes and rotation. */
export default function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
